module.exports = {"content":{},"productInfo":{"code":"{11E821B9-D69C-4150-A09B-DEB71738E64B}","name":"スペイン語（スペイン）　初中級","serialHead":"ZTNHR","courseResourceIDs":[{"levelNo":1,"resourceID":"32397bcd687fe0237e77b2007fbb78d70bf535b8"},{"levelNo":2,"resourceID":"7e49da59226e2ed562f037f4e4bf4647e2e88632"},{"levelNo":3,"resourceID":"fdd9976b203274a49528791c878a5915aee1d0e1"},{"levelNo":4,"resourceID":"5d4678d5b7f5696473b60acbaf3fad4a4ec25613"},{"levelNo":5,"resourceID":"7d57235ee26f05d705cd3a4d119c7b75ace7579a"}],"language":"es-ES","challengeCount":33842},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1